module.exports = __webpack_public_path__ + "img/Rust-3.6a8a1e60.png";